import React from "react";

import ptBr from "../../../config/texts/pt-br";
import Styles from "../styles/modal";
import { FormFull } from "form-full";
import { hooks, masks } from "../../../utils";
import {
  ButtonText,
  Input,
  InputAutocomplete,
  InputDate,
} from "../../../components/index";
import { fonts, Spacing, SVG } from "../../../config";
import { Grid, Button } from "@material-ui/core";
import { customModal } from "../../../components/modals/utils";
import { Visibility } from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { api } from "../../../services";
import ModalImage from "../../reservation/components/ModalImage";
import { ModalViewQRCode } from "../../reservation/components/ModalViewQRCode";
import { ThemeProvider, createTheme } from "@material-ui/core";
import { ButtonMenu, CustomText } from "../../../components/index";

function ModalViewMeusdados({ onSubmit, item }) {
  const texts = ptBr.login;
  const { call } = hooks.useRequest();
  const [QRCodeUrl, setQRCodeUrl] = React.useState("");
  const [viewPasswords, setViewPasswords] = React.useState(false);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#FFF",
      },
    },
  });

  function getButtons(itemGuest, fullItem) {
    if (itemGuest.imageId == null || itemGuest.imageId == undefined) {
      return [
        {
          label: "Link ",
          onClick: () =>
            customModal.setInfos(
              "Link da Imagem",
              [itemGuest.facialUrl],
              {
                onClick: () => {
                  customModal.close();
                  openModalView(fullItem);
                },
                label: "Voltar",
              },
              null,
              null,
              false,
              true,
              <Visibility />
            ),
        },
      ];
    } else {
      return [
        {
          label: "Link ",
          onClick: () => {
            customModal.setInfos(
              "Link da Imagem",
              [itemGuest.facialUrl],
              {
                onClick: () => {
                  customModal.close();
                  openModalView(fullItem);
                },
                label: "Voltar",
              },
              null,
              null,
              false,
              true,
              <Visibility />
            );
          },
        },
        {
          label: "Imagem",
          onClick: () => {
            openModalViewImg(fullItem, itemGuest);
          },
        },
      ];
    }
  }

  const drawMembers = (number: number) => {
    const membersForm: any = [];

    for (let index = 0; index < number; index++) {
      const [viewPasswordsSecondary, setViewPasswordsSecondary] =
        React.useState(false);
      const guest = item?.secondaryGuests[index] ?? {};
      membersForm.push(
        <div key={index} style={{ marginTop: 18 }}>
          <Styles.Barra></Styles.Barra>

          <CustomText
            fontFamily={fonts.bold}
            fontSize={14 / 8}
            textColor="#0C396D"
            style={{ paddingTop: 35, paddingBottom: 8 }}
          >
            Acompanhante Nº {String(index + 1).padStart(2, "0")}
          </CustomText>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6} lg={3}>
              <Styles.FieldCard>
                <Styles.FieldTitle>Nome Completo</Styles.FieldTitle>
                <Styles.FieldContent>{guest?.name || "-"}</Styles.FieldContent>
              </Styles.FieldCard>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Styles.FieldCard>
                <Styles.FieldTitle>CPF</Styles.FieldTitle>
                <Styles.FieldContent>
                  {guest?.document
                    ? masks.CPF(guest?.document)
                    : guest?.passport || "-"}
                </Styles.FieldContent>
              </Styles.FieldCard>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Styles.FieldCard>
                <Styles.FieldTitle>Data de Nascimento</Styles.FieldTitle>
                <Styles.FieldContent>
                  {guest?.birthDate ? masks.formatDate(guest?.birthDate) : "-"}
                </Styles.FieldContent>
              </Styles.FieldCard>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Styles.FieldCard>
                <div
                  style={{
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    width: "100%",
                    display: "block",
                  }}
                >
                  <Styles.FieldTitle
                    style={{
                      display: "inline",
                      whiteSpace: "nowrap",
                      minWidth: 0,
                    }}
                  >
                    E-Mail
                  </Styles.FieldTitle>
                  <Styles.FieldContent>
                    {guest?.email || "-"}
                  </Styles.FieldContent>
                </div>
              </Styles.FieldCard>
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <Styles.FieldCard>
                <Styles.FieldTitle>Telefone</Styles.FieldTitle>
                <Styles.FieldContent>
                  {guest?.phone ? masks.inputMaskTELWithDDD(guest?.phone) : "-"}
                </Styles.FieldContent>
              </Styles.FieldCard>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Styles.FieldCard>
                <Styles.FieldTitle>Senha de Acesso</Styles.FieldTitle>
                <Styles.FieldContent>
                  {guest?.passwords ? masks.passwords(guest?.passwords) : "-"}
                </Styles.FieldContent>
              </Styles.FieldCard>
            </Grid>
          </Grid>
        </div>
      );
    }
    return membersForm;
  };

  const openModalViewImg = (fullItem, imageData) => {
    customModal.setInfos(
      "doc-facial.png",
      [],
      {
        onClick: () => {
          customModal.close();
          openModalView(fullItem);
        },
        label: "Voltar",
      },
      null,
      <ModalImage item={imageData} />,
      false,
      true,
      null
    );
  };

  const openModalView = (item) => {
    customModal.setInfos(
      "Cadastrar Reserva",
      [],
      {
        onClick: () => {
          customModal.close();
        },
        label: "Voltar",
      },
      null,
      <ModalViewMeusdados
        item={item}
        onSubmit={(value) => console.log(value)}
      />,
      false,
      true,
      <SVG.File />
    );
  };

  function QrCodeModals() {
    customModal.setInfos(
      "Alerta QR Code",
      [
        "Gerar QR Code para acesso do Hóspede? Caso esse hospede já possua um QR Code, seu código antigo será invalidado.",
      ],
      {
        onClick: () => {
          customModal.close();
          call(null, api.getQRCode(item.id), (response) => {
            if (response.ok) {
              customModal.setInfos(
                "Vizualizar QR Code",
                [],
                {
                  onClick: () => {
                    customModal.close();
                  },
                  label: "Voltar",
                },
                null,
                <ModalViewQRCode qrCodeUrl={response?.data} />,
                false,
                true,
                <Visibility />
              );
            } else {
              console.log("Erro ao gerar QR Code");
              console.log(response);
              console.log(response.data);
              customModal.close();
            }
          });
        },
        label: "Gerar QR Code",
      },
      null,
      null,
      false,
      false,
      null
    );
  }

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          minWidth: "clamp(350x, 54vw, 1055px)",

          marginBottom: "20px",
          borderRadius: "15px",
          backgroundColor: "#FFF",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            maxHeight: "430px",
            borderRadius: "5px",
            backgroundColor: "#FFF",
          }}
        >
          <FormFull onSubmit={(data) => onSubmit(data)}>
            <Styles.InnerPanel>
              <CustomText
                fontFamily={fonts.bold}
                fontSize={14 / 8}
                textColor="#0C396D"
                style={{ paddingBottom: 8 }}
              >
                Locatário Primário
              </CustomText>
              <Grid container spacing={1}>
                <Grid item xs={12} md={12} lg={3}>
                  <Styles.FieldCard>
                    <Styles.FieldTitle>Nome Completo</Styles.FieldTitle>
                    <Styles.FieldContent>
                      {item?.primaryGuest?.name || "-"}
                    </Styles.FieldContent>
                  </Styles.FieldCard>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Styles.FieldCard>
                    <Styles.FieldTitle>CPF</Styles.FieldTitle>
                    <Styles.FieldContent>
                      {item?.primaryGuest?.document
                        ? masks.CPF(item?.primaryGuest?.document)
                        : item?.primaryGuest?.passport || "-"}
                    </Styles.FieldContent>
                  </Styles.FieldCard>
                </Grid>
                <Grid item xs={12} md={12} lg={3}>
                  <Styles.FieldCard>
                    <Styles.FieldTitle>Data de Nascimento</Styles.FieldTitle>
                    <Styles.FieldContent>
                      {item?.primaryGuest?.birthDate
                        ? masks.formatDate(item?.primaryGuest?.birthDate)
                        : "-"}
                    </Styles.FieldContent>
                  </Styles.FieldCard>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Styles.FieldCard>
                    <Styles.FieldTitle>E-Mail</Styles.FieldTitle>
                    <div
                      style={{
                        overflowX: "auto",
                        whiteSpace: "nowrap",
                        width: "100%",
                        display: "block",
                      }}
                    >
                      <Styles.FieldContent
                        style={{
                          display: "inline",
                          whiteSpace: "nowrap",
                          minWidth: 0,
                        }}
                      >
                        {item?.primaryGuest?.email || "-"}
                      </Styles.FieldContent>
                    </div>
                  </Styles.FieldCard>
                </Grid>
                <Grid item xs={12} md={12} lg={3}>
                  <Styles.FieldCard>
                    <Styles.FieldTitle>Telefone</Styles.FieldTitle>
                    <Styles.FieldContent>
                      {item?.primaryGuest?.phone
                        ? masks.inputMaskTELWithDDD(item?.primaryGuest?.phone)
                        : "-"}
                    </Styles.FieldContent>
                  </Styles.FieldCard>
                </Grid>

                <Grid item xs={12} md={3}>
                  <Styles.FieldCard>
                    <Styles.FieldTitle>Placa do Veículo</Styles.FieldTitle>
                    <Styles.FieldContent>
                      {item?.primaryGuest?.vehiclePlate || "-"}
                    </Styles.FieldContent>
                  </Styles.FieldCard>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Styles.FieldCard>
                    <Styles.FieldTitle>Assinatura Facial</Styles.FieldTitle>
                    <Styles.FieldContent>
                      {item?.primaryGuest?.imageId
                        ? "facial.jpeg"
                        : "Sem Imagem"}
                    </Styles.FieldContent>
                  </Styles.FieldCard>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Styles.FieldCard>
                    <Styles.FieldTitle>Senhas</Styles.FieldTitle>
                    <Styles.FieldContent>
                      {viewPasswords
                        ? item?.passwords && item?.primaryGuest?.passwords
                          ? [
                              ...item?.passwords,
                              ...item?.primaryGuest?.passwords,
                            ].join(", ")
                          : "-"
                        : masks.passwords(
                            item?.passwords && item?.primaryGuest?.passwords
                              ? [
                                  ...item?.passwords,
                                  ...item?.primaryGuest?.passwords,
                                ]
                              : []
                          )}

                      <ThemeProvider theme={theme}>
                        <Button
                          onClick={() => setViewPasswords(!viewPasswords)}
                          size="small"
                          style={{
                            padding: 0,
                            marginTop: -6,
                            minWidth: "100%",
                            minHeight: "10px",
                          }}
                        >
                          <VisibilityIcon />
                        </Button>
                      </ThemeProvider>
                    </Styles.FieldContent>
                  </Styles.FieldCard>
                </Grid>
              </Grid>

              {drawMembers(item.numGuests)}
            </Styles.InnerPanel>
          </FormFull>
        </div>
      </div>
    </>
  );
}

export default ModalViewMeusdados;
